/**
 * Enabled the number spinners for the quantity fields
 * 
 * @exports
 * @class QuantitySpinner
 */
import { newEvent } from '../../../helpers/event';

export class QuantitySpinner {
    private value: number;
    private container: HTMLElement;
    private input: HTMLInputElement;
    private min: number;
    private max: number;
    private step: number;
    private changeEvent: Event;

    constructor(container: HTMLElement) {
        this.container   = container;
        this.input       = <HTMLInputElement>this.container.querySelector('.js-quantity-selector__input');
        this.value       = Number(this.input.value);
        this.min         = this.input.min  ? Number(this.input.min) : 0;
        this.max         = this.input.max  ? Number(this.input.max) : Infinity;
        this.step        = this.input.step ? Number(this.input.step) : 1;
        this.changeEvent = newEvent('change');

        // Update our when if the field is manually updated
        this.input.addEventListener('change', () => {
            this.value = Number(this.input.value);
        });

        // Bind our events
        const decreaseBtn = this.container.querySelector('.js-quantity-selector__decrease');
        if(decreaseBtn) {
            decreaseBtn.addEventListener('click', () => {
                this.decreaseValue();
            });
        }
        const increaseBtn = this.container.querySelector('.js-quantity-selector__increase');
        if(increaseBtn) {
            increaseBtn.addEventListener('click', () => {
                this.increaseValue();
            });
        }
    }


    /**
     * Decrease the value by the step, or to the minimum value depending on whether the value minus the step
     * is lower than the minimum.
     * 
     * @private
     * @return void
     */
    private decreaseValue(): void {
        this.value       = Math.max(this.value - this.step, this.min);
        this.input.value = `${this.value}`;
        this.input.dispatchEvent(this.changeEvent);
    }


    /**
     * Increases the value by the step, or to the maximum value depending on whether the value plus the step
     * is higher than the maximum.
     * 
     * @private
     * @return void
     */
    private increaseValue(): void {
        this.value       = Math.min(this.value + this.step, this.max);
        this.input.value = `${this.value}`;
        this.input.dispatchEvent(this.changeEvent);
    }
}
